// Module
var code = `<div class="tool-strip{{isVertical?' vertical':''}}{{!isLeftOrTop ? ' rightOrDown':''}}{{onProcessMove?' moving':''}}" 
    style="left: {{left}}px; top: {{top}}px; {{>visibility}}"
    on-mouseup="onMouseUp">
    <div class="moveseporator" on-mousedown="onMovingBtnClick">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#moveSeparatorVertical"></use>
        </svg>
    </div>

    <div class="tool-strip-items-container" style="{{isVertical?'max-height':'max-width'}}:{{maxSize}}px;">
        <div class="tool-strip-items">
        {{#each toolStipItems: i}}
                <div class="tool-strip-item" on-pointerenter="@this.onToolStripItemPointerEnter(toolStipItems[i])" on-pointerleave="@this.onToolStripItemPointerLeave(toolStipItems[i])">
                    <terceraButton name="{{toolStipItems[i].name}}"
                                tooltip="{{toolStipItems[i].tooltip}}"
                                checked="{{toolStipItems[i].active}}"
                                enabled="{{toolStipItems[i].enabled}}"
                                visible="{{toolStipItems[i].visible}}"
                                SVG="true"
                                canCheck="true"
                                on-btnClick="@this.onItemClicked(this, event)"
                                terceraButtonStyle="js-chart-tool-button{{hoveredToolStripItem === toolStipItems[i] || openedToolStripItem === toolStipItems[i] ? ' hovered' : ''}}" />
                    {{#if toolStipItems[i].isGroup}}
                        <div class="tool-strip-item-arrow-container">
                            <div class="tool-strip-item-arrow{{openedToolStripItem === toolStipItems[i] ? ' opened' : ''}}" on-pointerenter="@this.showDropDownMenu(toolStipItems[i], event)">
                                <svg>
                                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowRightTrimmed"></use>
                                </svg>
                            </div>
                        </div>
                    {{/if}}
                </div>
            {{/each}}
        </div>    
    </div>
</div>`;
// Exports
export default code;